import React from 'react'
import { Grid2 } from "@mui/material";
import { ContactHeroDesktop } from './ContactHeroDesktop';
import { ContactConnectDesktop } from './ContactConnectDesktop';
import { ContactLocationDesktop } from './ContactLocationDesktop';

export const ContactDesktop = () => {
  return (
    <>
    <Grid2 >
        <ContactHeroDesktop/>
        <ContactLocationDesktop/>
        <ContactConnectDesktop/>
    </Grid2>
    </>
  )
}

